var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"vv-button",class:_vm.customClass,attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_vm._v("Button")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }